import { default as app, collapsibleHeaderClickEvent, onWindowResize, resetSelectionColumn, ToggleYellowToGreen, ToggleGreenToYellow, IsUndefinedOrNull } from '@legacy/App';

app.factory('ConfigurationFactory', ['$http', 'settings', function ($http, settings) {
    return {
        getConfigurationGroup: function () {
            return $http.get(settings.ApiURL + settings.ConfigurationURL + "/configurationgroup");
        },
        getConfigurationValue: function (configId, deviceId, driverId, groupId) {
            return $http.get(settings.ApiURL + settings.ConfigurationURL + "/getconfigvalue/" + configId + "/" + deviceId + "/" + driverId
                + "/" + groupId + '?noCache=' + new Date().getTime());
        },
        getConfigurationValues: function (groupId, deviceId, driverId, configGroupId) {
            return $http.get(settings.ApiURL + settings.ConfigurationURL + "/" + groupId + "/" + deviceId + "/" + driverId
                + "/" + configGroupId + '?noCache=' + new Date().getTime());
        },
        getConfigurationValuesBySearch: function (searchString, configurationType, deviceDriverId, configGroupId) {
            return $http.get(settings.ApiURL + settings.ConfigurationURL + "/search/" + searchString + "/" + configurationType
                + "/" + deviceDriverId + "/" + configGroupId);
        },
        getConfigurationValuesByGroupSpecific: function (groupId) {
            return $http.get(settings.ApiURL + settings.ConfigurationURL + "/groupspecific/" + groupId)
        },
        getConfigurationValuesByDeviceId: function (deviceId) {
            return $http.get(settings.ApiURL + settings.ConfigurationURL + "/device/" + deviceId)
        },
        deleteConfigurationValue: function (configId, deviceId, driverId, groupId) {
            return $http.delete(settings.ApiURL + settings.ConfigurationURL + "/" + configId + "/" + deviceId + "/" + driverId + "/" + groupId + '?noCache=' + new Date().getTime());
        },
        saveConfigurationValues: function (configurations, groupId, deviceId, driverId, configGroupId, isSearchActive) {
            var data = {
                configurationValueVM: configurations,
                configGroupId: isSearchActive == true ? null : configGroupId, //gruppe
                deviceId: deviceId,
                driverId: driverId,
                groupId: groupId, //svzgroupid
                isSearchActive: isSearchActive
            };
            return $http.put(settings.ApiURL + settings.ConfigurationURL + "/paste", data);
        },
        saveConfigurationValue: function (configValue) {
            return $http.put(settings.ApiURL + settings.ConfigurationURL + "/save1", configValue);
        },
        saveModalConfigurationValues: function (configuration) {
            return $http.put(settings.ApiURL + settings.ConfigurationURL + "/complex", configuration);
        },
        getDeviceList: function () {
            return $http.get(settings.ApiURL + settings.DeviceURL);
        },
        getDriverList: function () {
            return $http.get(settings.ApiURL + settings.DriverURL);
        },
        getConfigurationGroupList: function () {
            return $http.get(settings.ApiURL + settings.ConfigurationGroupURL);
        },
        getConfigurationGroupValues: function (groupId) {
            return $http.get(settings.ApiURL + settings.ConfigurationGroupURL + "/" + groupId);
        }
    };
}]);

app.controller('TranspacConfigurationController', ['$scope', '$parse', 'ConfigurationFactory', '$rootScope', 'settings', 'masterFactory', '$uibModal',
    function ($scope, $parse, ConfigurationFactory, $rootScope, settings, masterFactory, $uibModal) {
        $rootScope.pageTitle = "TransPac Configuration";
        $scope.configurationGroups = [];
        $scope.configurationGroupsList = [];
        $scope.selectedConfigurationGroupId = null;
        $scope.selectedGroupSpecificConfigurationGroup = false;
        $scope.groupSpecificConfigurationGroupNameId = null;
        $scope.selectedDeviceSpecific = false;
        $scope.configurationValues = [];
        $scope.groupConfigurationValues = [];
        $scope.configurationValues_Copy = {
            CopiedFromConfigurationType: null,
            SelectedGroupId: null,
            CopiedValue: []
        };
        $scope.error = "";
        $scope.isFormVisible = false;
        $scope.submitted = false;
        $scope.isSearchActive = false;
        $scope.searchString = "";

        // Initialization - this runs on load
        var init = function () {
            masterFactory.verifyAuthentication();
            $scope.selectedConfigurationType = "1";
            $scope.submitted = false;

            $('#loadingModal').modal({ backdrop: 'static' });
            ConfigurationFactory.getConfigurationGroup().success(function (data) {
                $scope.configurationGroups = data;
            }).error(function (data, status) {
                masterFactory.setError(status, data, $scope);
            }).finally(function () {
                $('#loadingModal').modal('hide');
            });
        };

        init();

        // On selecting a configuration from left side list
        $scope.getConfigurationValuesByGroupId = function (groupId, message) {
            $scope.closeAlert();
            $scope.selectedGroupSpecificConfigurationGroup = false;
            $scope.selectedConfigurationGroupId = groupId;// list of groups on the left
            $scope.selectedDeviceSpecific = false;
            $scope.searchString = "";
            $scope.isSearchActive = false;
            $scope.configurationValues = [];
            var deviceId = null;
            var driverId = null;
            var configGroupId = null;
            if ($scope.selectedConfigurationType == "2" && $scope.selectedDeviceDriver != null) {
                deviceId = $scope.selectedDeviceDriver;
            }
            else if ($scope.selectedConfigurationType == "3" && $scope.selectedDeviceDriver != null) {
                driverId = $scope.selectedDeviceDriver;
            }
            else if ($scope.selectedConfigurationType == "4") {
                configGroupId = $scope.groupSpecificConfigurationGroupNameId;
            }
            if ($scope.selectedConfigurationType == '1' || ($scope.selectedConfigurationType == '2' && deviceId != null) ||
                ($scope.selectedConfigurationType == '3' && driverId != null) ||
                ($scope.selectedConfigurationType == "4" && $scope.groupSpecificConfigurationGroupNameId != null)) {
                $('#loadingModal').modal({ backdrop: 'static' });
                ConfigurationFactory.getConfigurationValues(groupId, deviceId, driverId, configGroupId).success(function (data) {
                    $scope.configurationValues = data;
                    $scope.isFormVisible = true;
                    if (message != "")
                        $scope.notify.add({ type: 'success', title: 'Success!', body: message });
                }).error(function (data, status) {
                    $scope.isFormVisible = false;
                    masterFactory.setError(status, data, $scope);
                }).finally(function () {
                    $('#loadingModal').modal('hide');
                });
            }
        };

        $scope.getConfigurationValuesByConfigurationGroupId = function () {
            $scope.closeAlert();
            $scope.selectedGroupSpecificConfigurationGroup = true;
            $scope.selectedConfigurationGroupId = null;
            $scope.selectedDeviceSpecific = false;
            $scope.searchString = "";
            $scope.isSearchActive = false;
            $scope.configurationValues = [];
            if ($scope.selectedConfigurationType == "4" && $scope.groupSpecificConfigurationGroupNameId != null) {
                $('#loadingModal').modal({ backdrop: 'static' });
                ConfigurationFactory.getConfigurationValuesByGroupSpecific($scope.groupSpecificConfigurationGroupNameId).success(function (data) {
                    $scope.configurationValues = data;
                    $scope.isFormVisible = true;
                    if ($scope.configurationValues != null && $scope.configurationValues.length == 0) {
                        $scope.isFormVisible = false;
                        $scope.notify.add({ type: 'danger', title: 'Error!', body: 'No Configuration values found!' });
                    }
                }).error(function (data, status) {
                    $scope.isFormVisible = false;
                    masterFactory.setError(status, data, $scope);
                }).finally(function () {
                    $('#loadingModal').modal('hide');
                });
            }
        };

        $scope.getConfigurationValuesByDeviceId = function () {
            $scope.closeAlert();
            $scope.selectedConfigurationGroupId = null;
            $scope.selectedGroupSpecificConfigurationGroup = false;            
            $scope.selectedDeviceSpecific = true;
            $scope.searchString = "";
            $scope.isSearchActive = false;
            $scope.configurationValues = [];
            if ($scope.selectedConfigurationType == "2" && $scope.selectedDeviceDriver != null) {
                $('#loadingModal').modal({ backdrop: 'static' });
                ConfigurationFactory.getConfigurationValuesByDeviceId($scope.selectedDeviceDriver).success(function (data) {
                    $scope.configurationValues = data;
                    $scope.isFormVisible = true;
                    if ($scope.configurationValues != null && $scope.configurationValues.length == 0) {
                        $scope.isFormVisible = false;
                        $scope.notify.add({ type: 'danger', title: 'Error!', body: 'No Configuration values found!' });
                    }
                }).error(function (data, status) {
                    $scope.isFormVisible = false;
                    masterFactory.setError(status, data, $scope);
                }).finally(function () {
                    $('#loadingModal').modal('hide');
                });
            }
        };

        // searching configuration
        $scope.searchConfiguration = function (searchString) {
            $scope.error = null;
            var deviceDriverId = null;
            var configGroupId = null;
            if (!IsUndefinedOrNull(searchString)) {                
                if (searchString.length == 1 && isNaN(searchString)) { // if length == 1 and is not a number 
                    $scope.isFormVisible = false;
                }                
                else if (searchString.length >= 2 || (searchString.length == 1 && !isNaN(searchString))) { // if length > 1 || if length ==1 and is a number number
                    $scope.selectedConfigurationGroupId = null;
                    $('#loadingModal').modal({ backdrop: 'static' });

                    if ($scope.selectedConfigurationType == "2" || $scope.selectedConfigurationType == "3") {
                        if ($scope.selectedDeviceDriver != null && $scope.selectedDeviceDriver != -1)
                            deviceDriverId = $scope.selectedDeviceDriver;
                    }
                    else if ($scope.selectedConfigurationType == "4") {
                        configGroupId = $scope.groupSpecificConfigurationGroupNameId;
                    }

                    ConfigurationFactory.getConfigurationValuesBySearch(searchString, $scope.selectedConfigurationType, deviceDriverId, configGroupId).success(function (data) {
                        $scope.configurationValues = data;
                        $scope.isFormVisible = true;
                        $scope.isSearchActive = true;
                    }).error(function (data, status) {
                        $scope.isFormVisible = false;
                        masterFactory.setError(status, data, $scope);
                    }).finally(function () {
                        $('#loadingModal').modal('hide');
                    });
                }                
            }                
        };

        $scope.uiSelectStatusEnableDisable = function (control) {
            var str = control;
            // Get the model
            var model = $parse(str);
            // Assigns a value to it
            if ($scope.selectedConfigurationType != '1') {
                model.assign($scope, true);
            }
            else model.assign($scope, false);
        };

        // Button click functions and submit form function
        $scope.copyConfigurationValue = function () {
            $scope.configurationValues_Copy.CopiedFromConfigurationType = $scope.selectedConfigurationType;
            $scope.configurationValues_Copy.SelectedGroupId = $scope.selectedConfigurationGroupId != null ? $scope.selectedConfigurationGroupId : null;
            $scope.configurationValues_Copy.CopiedValue = angular.copy($scope.configurationValues);
            $scope.notify.add({ type: 'success', title: 'Success!', body: 'Configuration values copied successfully!' });
        };

        $scope.pasteConfigurationValue = function () {
            if ($scope.configurationValues_Copy.CopiedValue.length > 0) {
                // UI paste values 
                // Then save values to Server
                if ($scope.selectedConfigurationGroupId != null && $scope.selectedConfigurationGroupId == $scope.configurationValues_Copy.SelectedGroupId
                    && $scope.configurationValues_Copy.CopiedFromConfigurationType == $scope.selectedConfigurationType ) {
                    // copy from groupid to groupid && from device to device / driver to driver
                    if ($scope.selectedConfigurationType == "2") { // device to device copy
                        for (var i = 0; i < $scope.configurationValues_Copy.CopiedValue.length; i++) {
                            if ($scope.configurationValues[i].Id == $scope.configurationValues_Copy.CopiedValue[i].Id) {
                                if ($scope.configurationValues_Copy.CopiedValue[i].Type == 'xml') $scope.configurationValues[i].DeviceXmlSchema = $scope.configurationValues_Copy.CopiedValue[i].DeviceXmlSchema;
                                else if ($scope.configurationValues_Copy.CopiedValue[i].Type == 'bool') $scope.configurationValues[i].DeviceBooleanValue = $scope.configurationValues_Copy.CopiedValue[i].DeviceBooleanValue;
                                else if ($scope.configurationValues_Copy.CopiedValue[i].Type == 'flags') $scope.configurationValues[i].DeviceFlagsValue = $scope.configurationValues_Copy.CopiedValue[i].DeviceFlagsValue;
                                else $scope.configurationValues[i].DeviceValue = $scope.configurationValues_Copy.CopiedValue[i].DeviceValue;
                            }
                        }
                    }
                    else if ($scope.selectedConfigurationType == "3") { // driver to driver copy
                        for (i = 0; i < $scope.configurationValues_Copy.CopiedValue.length; i++) {
                            if ($scope.configurationValues[i].Id == $scope.configurationValues_Copy.CopiedValue[i].Id) {
                                if ($scope.configurationValues_Copy.CopiedValue[i].Type == 'xml') $scope.configurationValues[i].DriverXmlSchema = $scope.configurationValues_Copy.CopiedValue[i].DriverXmlSchema;
                                else if ($scope.configurationValues_Copy.CopiedValue[i].Type == 'bool') $scope.configurationValues[i].DriverBooleanValue = $scope.configurationValues_Copy.CopiedValue[i].DriverBooleanValue;
                                else if ($scope.configurationValues_Copy.CopiedValue[i].Type == 'flags') $scope.configurationValues[i].DriverFlagsValue = $scope.configurationValues_Copy.CopiedValue[i].DriverFlagsValue;
                                else $scope.configurationValues[i].DriverValue = $scope.configurationValues_Copy.CopiedValue[i].DriverValue;
                            }
                        }
                    }
                    // Then save values to Server
                    var groupId = null, deviceId = null, driverId = null, configGroupId = null;
                    if ($scope.selectedConfigurationType == "2" && $scope.selectedDeviceDriver != null) {
                        deviceId = $scope.selectedDeviceDriver;
                    }
                    else if ($scope.selectedConfigurationType == "3" && $scope.selectedDeviceDriver != null) {
                        driverId = $scope.selectedDeviceDriver;
                    }
                    else if ($scope.selectedConfigurationType == "4") {
                        groupId = $scope.groupSpecificConfigurationGroupNameId;
                    }
                    configGroupId = $scope.selectedConfigurationGroupId;

                    $('#loadingModal').modal({ backdrop: 'static' });
                    ConfigurationFactory.saveConfigurationValues($scope.configurationValues, groupId, deviceId, driverId, configGroupId, $scope.isSearchActive).success(function (data) {
                        // code to get the configuration group/ search string values again and display.                 
                        if (!IsUndefinedOrNull($scope.searchString) && $scope.isSearchActive) {
                            $scope.searchConfiguration($scope.searchString);
                        }
                        else if ($scope.selectedConfigurationGroupId == null)
                            $scope.getConfigurationValuesByConfigurationGroupId();
                        else
                            $scope.getConfigurationValuesByGroupId($scope.selectedConfigurationGroupId, "");                        
                        $scope.notify.add({ type: 'success', title: 'Success!', body: 'Configuration Values pasted successfully' });
                    }).error(function (data, status) {
                        masterFactory.setError(status, data, $scope);
                    }).finally(function () {
                        $('#loadingModal').modal('hide');
                    });
                    
                    
                }
                //else if ($scope.selectedConfigurationGroupId == null && $scope.selectedConfigurationType == "4"
                //    && $scope.configurationValues_Copy.SelectedGroupId == null) {
                //    // copy from config group to config group
                //    for (var i = 0; i < $scope.configurationValues_Copy.CopiedValue.length; i++) {
                //        $scope.configurationValues_Copy.CopiedValue[i].DefaultValue = null;
                //        $scope.configurationValues_Copy.CopiedValue[i].DefaultFlagsValue = null;
                //        $scope.configurationValues_Copy.CopiedValue[i].DefaultBooleanValue = null;
                //        $scope.configurationValues_Copy.CopiedValue[i].DefaultXmlSchema = null;
                //    }
                //    $scope.configurationValues = angular.copy($scope.configurationValues_Copy.CopiedValue);                    
                //    $scope.isFormVisible = true;
                //    $scope.notify.add({ type: 'success', title: 'Success!', body: 'Configuration values pasted successfully!' });
                //}
                else {
                    $scope.notify.add({ type: 'danger', title: 'Error!', body: 'Cannot paste configuration values!' });
                }
            }
        };

        $scope.submitForm = function () {
            //if ($scope.configurationForm.$valid) {
            //    $scope.saveConfigurationValues();
            //    $scope.configurationForm.submitted = false;
            //} else {
            //    $scope.configurationForm.submitted = true;
            //}
        };

        $scope.saveConfigurationValues = function () {
            var groupId = null, deviceId = null, driverId = null, configGroupId = null;
            if ($scope.selectedConfigurationType == "2" && $scope.selectedDeviceDriver != null) {
                deviceId = $scope.selectedDeviceDriver;
            }
            else if ($scope.selectedConfigurationType == "3" && $scope.selectedDeviceDriver != null) {
                driverId = $scope.selectedDeviceDriver;
            }
            else if ($scope.selectedConfigurationType == "4") {
                groupId = $scope.groupSpecificConfigurationGroupNameId; 
            }
            configGroupId = $scope.selectedConfigurationGroupId;            

            $('#loadingModal').modal({ backdrop: 'static' });
            ConfigurationFactory.saveConfigurationValues($scope.configurationValues, groupId, deviceId, driverId, configGroupId, $scope.isSearchActive).success(function (data) {
                // code to get the configuration group/ search string values again and display.                 
                if (!IsUndefinedOrNull($scope.searchString) && $scope.isSearchActive) {
                    $scope.searchConfiguration($scope.searchString);
                }
                else if ($scope.selectedConfigurationGroupId == null)
                    $scope.getConfigurationValuesByConfigurationGroupId();
                else
                    $scope.getConfigurationValuesByGroupId($scope.selectedConfigurationGroupId, "");
                ToggleYellowToGreen();
                $scope.notify.add({ type: 'success', title: 'Success!', body: 'Updated Configuration details successfully' });
            }).error(function (data, status) {
                masterFactory.setError(status, data, $scope);
            }).finally(function () {
                $('#loadingModal').modal('hide');
            });
        };

        $scope.saveConfigurationValueOnBlur = function (configValue, index) {
            if (configValue.IsChanged == true) {
                // check if field exist's in the form and if it is valid 
                // or
                // check if field doesn't exist's                
                if ( (
                        !IsUndefinedOrNull($scope.transPacConfigurationForm[configValue.Type + configValue.Id]) && 
                        !$scope.transPacConfigurationForm[configValue.Type + configValue.Id].$error.pattern
                      ) || 
                      (
                        IsUndefinedOrNull($scope.transPacConfigurationForm[configValue.Type + configValue.Id])
                      )
                    ) {
                    // Saving default config value id, value
                    if ($scope.selectedConfigurationType == "1") {

                    }
                        // Saving Device Config Value device id, id, value
                    else if ($scope.selectedConfigurationType == "2") {
                        configValue.deviceId = $scope.selectedDeviceDriver;
                    }
                        // Saving Driver Config Value driver id, id, value
                    else if ($scope.selectedConfigurationType == "3") {
                        configValue.driverId = $scope.selectedDeviceDriver;
                    }
                        // Saving Group Config Value group id, id, value
                    else if ($scope.selectedConfigurationType == "4") {
                        configValue.GroupId = $scope.groupSpecificConfigurationGroupNameId;
                    }
                    ConfigurationFactory.saveConfigurationValue(configValue).success(function (data) {
                        $scope.notify.add({ type: 'success', title: 'Success!', body: 'Saved Configuration ' + configValue.Id + ' - ' + configValue.Name });
                        if ($scope.selectedConfigurationType == "2" && $scope.selectedDeviceSpecific == true) {
                            $scope.getConfigurationValuesByDeviceId();
                        }
                        else if ($scope.selectedConfigurationType == "4" && $scope.selectedGroupSpecificConfigurationGroup == true) {
                            $scope.getConfigurationValuesByConfigurationGroupId();
                        }
                        else // code to get config value by id to display deleted value.                    
                            ConfigurationFactory.getConfigurationValue(configValue.Id, configValue.deviceId, configValue.driverId, configValue.GroupId).success(function (data) {
                                $scope.configurationValues[index] = angular.copy(data);
                            }).error(function () {
                                masterFactory.setError(status, data, $scope);
                            });
                    }).error(function (data, status) {
                        masterFactory.setError(status, data, $scope);
                    }).finally(function () {
                        configValue.IsChanged = false;
                        configValue.IsSubmitted = false;
                    }); 
                }
                else { // invalid form
                    configValue.IsSubmitted = true;
                }
            }            
        };

        $scope.saveFlagsConfigurationValueOnChange = function (configValue) {
            configValue.IsChanged = true;
            $scope.saveConfigurationValueOnBlur(configValue);
        };

        $scope.resetConfigurationValue = function (configValue, configValueType) {
            if (configValue.IsChanged == true) {
                    // Cancel default config value
                if (configValueType == 'DEFAULT') {
                    if (configValue.Type == "xml") {
                        configValue.DefaultXmlSchema = configValue.OriginalXmlSchema;
                    }
                    else if (configValue.Type == "bool") {
                        configValue.DefaultBooleanValue = configValue.OriginalBooleanValue;
                    }
                    else if (configValue.Type == "flags") {
                        configValue.DefaultFlagsValue = configValue.OriginalFlagsValue;
                    }
                    else if (configValue.Type == "color" || configValue.Type == "dastr" || configValue.Type == "float" ||
                            configValue.Type == "int" || configValue.Type == "str") {
                        configValue.DefaultValue = configValue.OriginalValue;
                    }
                    configValue.IsChanged = false;
                }
                    // Cancel Device Config Value
                else if (configValueType == 'DEVICE') {
                    if (configValue.Type == "xml") {
                        configValue.DeviceXmlSchema = configValue.OriginalXmlSchema;
                    }
                    else if (configValue.Type == "bool") {
                        configValue.DeviceBooleanValue = configValue.OriginalBooleanValue;
                    }
                    else if (configValue.Type == "flags") {
                        configValue.DeviceFlagsValue = configValue.OriginalFlagsValue;
                    }
                    else if (configValue.Type == "color" || configValue.Type == "dastr" || configValue.Type == "float" ||
                            configValue.Type == "int" || configValue.Type == "str") {
                        configValue.DeviceValue = configValue.OriginalValue;
                    }
                    configValue.IsChanged = false;
                }
                    // Cancel Driver Config Value
                else if (configValueType == 'DRIVER') {
                    if (configValue.Type == "xml") {
                        configValue.DriverXmlSchema = configValue.OriginalXmlSchema;
                    }
                    else if (configValue.Type == "bool") {
                        configValue.DriverBooleanValue = configValue.OriginalBooleanValue;
                    }
                    else if (configValue.Type == "flags") {
                        configValue.DriverFlagsValue = configValue.OriginalFlagsValue;
                    }
                    else if (configValue.Type == "color" || configValue.Type == "dastr" || configValue.Type == "float" ||
                            configValue.Type == "int" || configValue.Type == "str") {
                        configValue.DriverValue = configValue.OriginalValue;
                    }
                    configValue.IsChanged = false;
                }
                    // Cancel Group Config Value 
                else if (configValueType == 'GROUP') {
                    if (configValue.Type == "xml") {
                        configValue.GroupXmlSchema = configValue.OriginalXmlSchema;
                    }
                    else if (configValue.Type == "bool") {
                        configValue.GroupBooleanValue = configValue.OriginalBooleanValue;
                    }
                    else if (configValue.Type == "flags") {
                        configValue.GroupFlagsValue = configValue.OriginalFlagsValue;
                    }
                    else if (configValue.Type == "color" || configValue.Type == "dastr" || configValue.Type == "float" ||
                            configValue.Type == "int" || configValue.Type == "str") {
                        configValue.GroupValue = configValue.OriginalValue;
                    }
                    configValue.IsChanged = false;
                }
            }
        };

        $scope.preDeleteConfigurationValue = function (configValue, index) {
            if (configValue.Type == 'xml') {
                //Display delete confirmation modal
                var modalInstance = $uibModal.open({
                    backdrop: 'static',
                    templateUrl: 'app-legacy/Entities/templates/deleteComplexConfigurationModal.html',
                    controller: 'DeleteComplexConfigurationModalController',
                    controllerAs: 'modalVm',
                    size: 'sm',
                    scope: $scope,
                    resolve: {
                        DeleteModalValues: function () {
                            var returnvalue = { configValue: configValue, index: index };
                            return returnvalue;
                        }
                    }
                });
                modalInstance.result.then(function (value) {
                    if (value == 1) {
                        $scope.deleteConfigurationValue(configValue, index)
                    }
                }, function () {

                });                
            }
            else $scope.deleteConfigurationValue(configValue, index);
        }

        $scope.deleteConfigurationValue = function (configValue, index) {
            if ($scope.selectedConfigurationType == "1") {

            }
                // Saving Device Config Value device id, id, value
            else if ($scope.selectedConfigurationType == "2") {
                configValue.deviceId = $scope.selectedDeviceDriver;
            }
                // Saving Driver Config Value driver id, id, value
            else if ($scope.selectedConfigurationType == "3") {
                configValue.driverId = $scope.selectedDeviceDriver;
            }
                // Saving Group Config Value group id, id, value
            else if ($scope.selectedConfigurationType == "4") {
                configValue.GroupId = $scope.groupSpecificConfigurationGroupNameId;
            }
            ConfigurationFactory.deleteConfigurationValue(configValue.Id, configValue.deviceId, configValue.driverId, configValue.GroupId)
                .success(function (data) {
                    $scope.notify.add({ type: 'success', title: 'Success!', body: 'Deleted Configuration ' + configValue.Id + ' - ' + configValue.Name });
                    if ($scope.selectedConfigurationType == "2" && $scope.selectedDeviceSpecific == true) {
                        $scope.getConfigurationValuesByDeviceId();
                    }
                    else if ($scope.selectedConfigurationType == "4" && $scope.selectedGroupSpecificConfigurationGroup == true) {
                        $scope.getConfigurationValuesByConfigurationGroupId();
                    }
                    else // code to get config value by id to display deleted value.                    
                    ConfigurationFactory.getConfigurationValue(configValue.Id, configValue.deviceId, configValue.driverId, configValue.GroupId).success(function (data) {
                        $scope.configurationValues[index] = angular.copy(data);
                    }).error(function () {
                        masterFactory.setError(status, data, $scope);
                    });
            }).error(function (data, status) {
                masterFactory.setError(status, data, $scope);
            }).finally(function () {                
            });            
        };

        $scope.disableEnableDeleteButton = function (configValue, configValueType) {
            if (configValueType == 'DEFAULT')
            {
                if (configValue.Type == "xml") {
                    return configValue.DefaultXmlSchema == null ? true : false;
                }
                else if (configValue.Type == "bool") {
                    return configValue.DefaultBooleanValue == null ? true : false;
                }
                else if (configValue.Type == "flags") {
                    return configValue.DefaultFlagsValue == null ? true : false;
                }
                else if (configValue.Type == "color" || configValue.Type == "dastr" || configValue.Type == "float" ||
                        configValue.Type == "int" || configValue.Type == "str") {
                    return configValue.DefaultValue == null ? true : false;
                }
            }
            else if (configValueType == 'DEVICE') {
                if (configValue.Type == "xml") {
                    return configValue.DeviceXmlSchema == null ? true : false;
                }
                else if (configValue.Type == "bool") {
                    return configValue.DeviceBooleanValue == null ? true : false;
                }
                else if (configValue.Type == "flags") {
                    return configValue.DeviceFlagsValue == null ? true : false;
                }
                else if (configValue.Type == "color" || configValue.Type == "dastr" || configValue.Type == "float" ||
                        configValue.Type == "int" || configValue.Type == "str") {
                    return configValue.DeviceValue == null ? true : false;
                }
            }
            else if (configValueType == 'DRIVER') {
                if (configValue.Type == "xml") {
                    return configValue.DriverXmlSchema == null ? true : false;
                }
                else if (configValue.Type == "bool") {
                    return configValue.DriverBooleanValue == null ? true : false;
                }
                else if (configValue.Type == "flags") {
                    return configValue.DriverFlagsValue == null ? true : false;
                }
                else if (configValue.Type == "color" || configValue.Type == "dastr" || configValue.Type == "float" ||
                        configValue.Type == "int" || configValue.Type == "str") {
                    return configValue.DriverValue == null ? true : false;
                }
            }
            else if (configValueType == 'GROUP') {
                if (configValue.Type == "xml") {
                    return configValue.GroupXmlSchema == null ? true : false;
                }
                else if (configValue.Type == "bool") {
                    return configValue.GroupBooleanValue == null ? true : false;
                }
                else if (configValue.Type == "flags") {
                    return configValue.GroupFlagsValue == null ? true : false;
                }
                else if (configValue.Type == "color" || configValue.Type == "dastr" || configValue.Type == "float" ||
                        configValue.Type == "int" || configValue.Type == "str") {
                    return configValue.GroupValue == null ? true : false;
                }
            }
            

        };

        function MapListToFlagsValue(flagsValue) {
            var result = 0;
            for (var i = 0; i < flagsValue.length; i++) {
                result = result | flagsValue[i];
            }
            return result;
        }
        
        // Helping functions and events
        $scope.closeAlert = function () {
            $scope.error = null;
        };

        $scope.onConfigurationTypeChange = function () {
            $scope.entities = [];
            $scope.configurationValues = [];            
            //$scope.selectedConfigurationGroupId = null;
            if ($scope.selectedConfigurationType == "1") {
                $scope.onDeviceDriverChange();
            }
            else if ($scope.selectedConfigurationType == "2") {                
                ConfigurationFactory.getDeviceList().success(function (data) {
                    $scope.entities = data;
                    $scope.selectedDeviceDriver = $scope.entities[0].Id;
                }).error(function (data, status) {
                    masterFactory.setError(status, data, $scope);
                }).finally(function () {
                    $scope.onDeviceDriverChange();
                });
            }
            else if ($scope.selectedConfigurationType == "3") {
                ConfigurationFactory.getDriverList().success(function (data) {
                    $scope.entities = data;
                    $scope.selectedDeviceDriver = $scope.entities[0].Id;
                }).error(function (data, status) {
                    masterFactory.setError(status, data, $scope);
                }).finally(function () {
                    $scope.onDeviceDriverChange();
                });
            }
            else if ($scope.selectedConfigurationType == "4") {
                ConfigurationFactory.getConfigurationGroupList().success(function (data) {
                    $scope.configurationGroupsList = data;
                    $scope.groupSpecificConfigurationGroupNameId = $scope.configurationGroupsList[0].Id;
                }).error(function (data, status) {
                    masterFactory.setError(status, data, $scope);
                }).finally(function () {
                    $scope.onConfigurationGroupChange();
                });
            }
        };

        $scope.onDeviceDriverChange = function () {
            $scope.configurationValues = [];
            // selectedConfigurationType == "1" - Default Configuration Value
            // selectedConfigurationType == "2 or 3" - Device or Driver Configuration Value            
            if ($scope.selectedConfigurationType == "1") {
                if ($scope.selectedConfigurationGroupId != null) $scope.getConfigurationValuesByGroupId($scope.selectedConfigurationGroupId, '');
                else $scope.getConfigurationValuesByGroupId(0, '');
            }
            else if ($scope.selectedConfigurationType == "2" ) {
                if ($scope.selectedConfigurationGroupId != null && $scope.selectedDeviceSpecific == false)
                    $scope.getConfigurationValuesByGroupId($scope.selectedConfigurationGroupId, '');
                else $scope.getConfigurationValuesByDeviceId();
            }
            else if ($scope.selectedConfigurationType == "3") {
                if ($scope.selectedConfigurationGroupId != null) $scope.getConfigurationValuesByGroupId($scope.selectedConfigurationGroupId, '');
                else $scope.getConfigurationValuesByGroupId(0, '');
            }
        };

        $scope.onConfigurationGroupChange = function () {
            if ($scope.groupSpecificConfigurationGroupNameId != null) {
                $scope.getConfigurationValuesByConfigurationGroupId();
            }
            else {
                $scope.getConfigurationValuesByGroupId($scope.selectedConfigurationGroupId, '');
            }
        };

        $scope.setBoolValue = function (configurationvalue) {
            if (configurationvalue.BooleanValue == true) configurationvalue.UIValue = "1";
            else configurationvalue.UIValue = "0";
            configurationvalue.IsChanged = true;
        };

        $scope.ShowCopyButton = function () {
            if (($scope.selectedConfigurationType == "2" && $scope.selectedDeviceSpecific == false)
                || $scope.selectedConfigurationType == "3") {
                if ($scope.configurationValues.length > 0 && $scope.isSearchActive == false) return true;
                else return false;
            }
            else return false;
            //else if ($scope.selectedConfigurationType == "4") {
            //    if ($scope.configurationValues.length > 0 && $scope.isSearchActive == false) {
            //        if ($scope.selectedGroupSpecificConfigurationGroup == true) {
            //            return true;
            //        }
            //        else return false;
            //    }
            //    else {
            //        return false;
            //    }
            //}
        };

        $scope.ShowPasteButton = function () {
            if (($scope.selectedConfigurationType == "2" && $scope.selectedDeviceSpecific == false)
                || $scope.selectedConfigurationType == "3") {
                if ($scope.configurationValues.length > 0 && $scope.isSearchActive == false) return true;
                else return false;
            }
            else return false;
            //else if ($scope.selectedConfigurationType == "4") {
            //    if ($scope.configurationValues.length > 0 && $scope.isSearchActive == false) {
            //        if ($scope.selectedGroupSpecificConfigurationGroup == true) {
            //            return true;
            //        }
            //        else return false;
            //    }
            //    else if ($scope.configurationValues.length == 0) {
            //        if ($scope.configurationValues_Copy.CopiedValue.length > 0) return true;
            //        else false;
            //    }
            //}
        };

        $scope.viewEditComplexConfigValue = function (configurationValue) {
            var modalInstance = $uibModal.open({
                backdrop: 'static',
                templateUrl: 'app-legacy/Entities/templates/complexConfigurationModal_transpac.html',
                windowClass : "complexConfigurationModal_transpac",
                controller: 'ConfigurationModalController',
                controllerAs: 'modalVm',
                size: 'lg',
                scope: $scope,
                resolve: {
                    ComplexConfigurationValue: function () {
                        configurationValue.deviceId = null;
                        configurationValue.driverId = null;
                        if ($scope.selectedConfigurationType == "2") {
                            configurationValue.deviceId = $scope.selectedDeviceDriver;
                            configurationValue.XmlSchema = angular.copy(configurationValue.DeviceXmlSchema);
                        }
                        else if ($scope.selectedConfigurationType == "3") {
                            configurationValue.driverId = $scope.selectedDeviceDriver;
                            configurationValue.XmlSchema = angular.copy(configurationValue.DriverXmlSchema);
                        }
                        else if ($scope.selectedConfigurationType == "4") {
                            configurationValue.GroupId = $scope.groupSpecificConfigurationGroupNameId;
                            configurationValue.XmlSchema = angular.copy(configurationValue.GroupXmlSchema);
                        }
                        else {
                            configurationValue.XmlSchema = angular.copy(configurationValue.DefaultXmlSchema);
                        }
                        return configurationValue;
                    }
                }
            });
            modalInstance.result.then(function (message) {
                if (message == 'ok') {
                    // code to get the configuration group/ search string values again and display. 
                    if (!IsUndefinedOrNull($scope.searchString) && $scope.isSearchActive) {
                        $scope.searchConfiguration($scope.searchString);
                    }
                    else {
                        if ($scope.selectedConfigurationGroupId == null) {
                            // specific device or specific group
                            if ($scope.selectedGroupSpecificConfigurationGroup == true) $scope.getConfigurationValuesByConfigurationGroupId();
                            else if ($scope.selectedDeviceSpecific == true) $scope.getConfigurationValuesByDeviceId();
                        }                            
                        else
                            $scope.getConfigurationValuesByGroupId($scope.selectedConfigurationGroupId, "");
                    }
                }

            }, function () {

            });
        };

        $scope.viewComplexConfigValue = function (configurationValue, configTypeToDisplay) {
            var modalInstance = $uibModal.open({
                backdrop: 'static',
                templateUrl: 'app-legacy/Entities/templates/defaultcomplexConfigurationModal.html',
                controller: 'DefaultConfigurationModalController',
                controllerAs: 'modalVm',
                size: 'lg',
                scope: $scope,
                resolve: {
                    ComplexConfigurationValue: function () {
                        configurationValue.deviceId = null;
                        configurationValue.driverId = null;
                        if (configTypeToDisplay == 'DEFAULT') {
                            configurationValue.XmlSchema = angular.copy(configurationValue.DefaultXmlSchema);
                        }
                        else if (configTypeToDisplay == 'GROUP') {
                            configurationValue.XmlSchema = angular.copy(configurationValue.GroupXmlSchema);
                        }
                        return configurationValue;
                    }
                }
            });
        };

    }]);

app.controller('ConfigurationModalController', ['$scope', 'ConfigurationFactory', '$uibModalInstance', 'ComplexConfigurationValue', '$filter', '$uibModal', 'masterFactory', '$timeout',
    function ($scope, ConfigurationFactory, $uibModalInstance, ComplexConfigurationValue, $filter, $uibModal, masterFactory, $timeout) {
        var modalVm = this;

        init();

        modalVm.labelConfig = $scope.getLables(ComplexConfigurationValue.Id);
        modalVm.copyConfigValue = function (index, isLast) {
            if (modalVm.IsSingle) {
                modalVm.CopiedConfigValue.CopiedValue = angular.copy(modalVm.ComplexConfigurationValue.XmlSchema.fieldSequence[0]);
                $scope.modalNotify.add({ type: 'success', title: 'Success!', body: 'Copied config values successfully' });
            }
            else { // multi form complex configuration
                modalVm.MultiFormSettings.copiedForm = angular.copy(modalVm.MultiFormSettings.stagingComplexConfig[modalVm.MultiFormSettings.selectedFormIndex]);
                $scope.modalNotify.add({ type: 'success', title: 'Success!', body: 'Copied config values successfully' });
            }
        };

        modalVm.pasteConfigValue = function () {
            if (modalVm.IsSingle) {
                // when issingle then copy/paste is between different modals so have to look into it. 
            }
            else {
                //modalVm.MultiFormSettings.stagingComplexConfig[modalVm.MultiFormSettings.selectedFormIndex] =
                //    angular.copy(modalVm.MultiFormSettings.copiedForm);
                modalVm.MultiFormSettings.stagingComplexConfig[modalVm.MultiFormSettings.selectedFormIndex] =
                    angular.copy(modalVm.MultiFormSettings.copiedForm);
                $scope.modalNotify.add({ type: 'success', title: 'Success!', body: 'Paste config values successfully' });
            }
        };

        modalVm.reset = function () {
            if (modalVm.IsSingle) {
                modalVm.ComplexConfigurationValue.XmlSchema.fieldSequence[0] = angular.copy(modalVm.ResetComplexConfigurationValue.XmlSchema.fieldSequence[0]);
                $scope.modalNotify.add({ type: 'success', title: 'Success!', body: 'Config values Reset successfully' });
            }
            else {
                if (modalVm.IsAddNew) { // is new
                    modalVm.MultiFormSettings.stagingComplexConfig[modalVm.MultiFormSettings.selectedFormIndex] = angular.copy(modalVm.MultiFormSettings.newForm[0]);
                }
                else { // existing form
                    if (modalVm.MultiFormSettings.selectedFormIndex < modalVm.ComplexConfigurationValue.XmlSchema.fieldSequence.length)
                        modalVm.MultiFormSettings.stagingComplexConfig[modalVm.MultiFormSettings.selectedFormIndex]
                            = angular.copy(modalVm.ComplexConfigurationValue.XmlSchema.fieldSequence[modalVm.MultiFormSettings.selectedFormIndex]);
                    else modalVm.MultiFormSettings.stagingComplexConfig[modalVm.MultiFormSettings.selectedFormIndex] = angular.copy(modalVm.MultiFormSettings.newForm[0]);
                }
                $scope.modalNotify.add({ type: 'success', title: 'Success!', body: 'Config values Reset successfully' });
            }
        };

        modalVm.delete = function myfunction() {
            modalVm.MultiFormSettings.stagingComplexConfig.splice(modalVm.MultiFormSettings.selectedFormIndex, 1);
            $scope.modalNotify.add({ type: 'success', title: 'Success!', body: 'Config values deleted successfully' });
            if (modalVm.MultiFormSettings.stagingComplexConfig.length > 0)
                modalVm.MultiFormSettings.selectedFormIndex = 0;
        };

        modalVm.save = function (index, last) {
            $scope.error = null;
            $('#loadingModal').modal({ backdrop: 'static' });
            if (!modalVm.IsSingle) {
                modalVm.ComplexConfigurationValue.XmlSchema.fieldSequence = angular.copy(modalVm.MultiFormSettings.stagingComplexConfig);
                //modalVm.MultiFormSettings.stagingComplexConfig = angular.copy()
            }
            else {
                modalVm.ResetComplexConfigurationValue.XmlSchema.fieldSequence[0] = angular.copy(modalVm.ComplexConfigurationValue.XmlSchema.fieldSequence[0]);
            }
            ConfigurationFactory.saveModalConfigurationValues(modalVm.ComplexConfigurationValue).success(function (data) {
                modalVm.ModalHeading = modalVm.ComplexConfigurationValue.Name;
                modalVm.IsAddNew = false;
                $scope.modalNotify.add({ type: 'success', title: 'Success!', body: 'Saved Configuration details successfully' });
            }).error(function (data, status) {
                $scope.error = data.Message;
            }).finally(function () {
                $('#loadingModal').modal('hide');
            });
        };

        modalVm.cancel = function () {
            $uibModalInstance.close('ok');
        };

        modalVm.initSortedList = function myfunction(complexItem) {
            $scope.MyComplexItem = complexItem;
            $scope.MyComplexItem.fieldValue = $filter('filter')(complexItem.fieldOptions, { IsSelected: true });
        };

        modalVm.sortableOptions = {
            update: function (e, ui) {
                console.log("update");
            },
            stop: function (e, ui) {
                console.log("stop");
                var filteredOptions = $filter('filter')(ui.item.sortable.sourceModel, { IsSelected: true });
                if (filteredOptions.length > 0)
                    $scope.MyComplexItem.fieldValue = filteredOptions;
            }
        };

        modalVm.UpdateSeletedSortedList = function (complexitem) {
            $scope.MyComplexItem.fieldValue = $filter('filter')(complexitem.fieldOptions, { IsSelected: true });
        };

        modalVm.formSelected = function (index) {
            modalVm.ModalHeading = modalVm.ComplexConfigurationValue.Name;
            modalVm.IsAddNew = false;
            modalVm.MultiFormSettings.selectedFormIndex = index;
        };

        modalVm.AddNewRegister = function () {
            modalVm.ModalHeading = modalVm.labelConfig.addModalTitle;
            modalVm.IsAddNew = true;
            modalVm.MultiFormSettings.stagingComplexConfig.push(angular.copy(modalVm.MultiFormSettings.newForm[0]));
            modalVm.MultiFormSettings.selectedFormIndex = modalVm.MultiFormSettings.stagingComplexConfig.length - 1;
        };

        function init() {
            modalVm.ActiveTab = 0;
            modalVm.SortedSelectedList = {};
            modalVm.ComplexConfigurationValue = angular.copy(ComplexConfigurationValue);
            modalVm.ResetComplexConfigurationValue = angular.copy(ComplexConfigurationValue);
            modalVm.ModalHeading = modalVm.ComplexConfigurationValue.Name;
            modalVm.IsAddNew = false;
            modalVm.CopiedConfigValue = {
                Id: ComplexConfigurationValue.Id, GroupId: ComplexConfigurationValue.ConfigurationGroupId,
                Type: ComplexConfigurationValue.Type, CopiedValue: []
            };
            modalVm.IsSingle = modalVm.ComplexConfigurationValue.XmlSchema.isSingle;
            if (!modalVm.IsSingle) { // multi form settings
                modalVm.MultiFormSettings = {
                    newForm: angular.copy(modalVm.ComplexConfigurationValue.XmlSchema.fieldSequence.splice(modalVm.ComplexConfigurationValue.XmlSchema.fieldSequence.length - 1, 1)),
                    stagingComplexConfig: angular.copy(modalVm.ComplexConfigurationValue.XmlSchema.fieldSequence),
                    selectedFormIndex: 0,
                    copiedForm: null
                };
            }


        };
    }]);

app.controller('DefaultConfigurationModalController', ['$scope', '$uibModalInstance', 'ComplexConfigurationValue', '$filter', '$uibModal',
    function ($scope, $uibModalInstance, ComplexConfigurationValue, $filter, $uibModal) {
        var modalVm = this;

        modalVm.labelConfig = $scope.getLables(ComplexConfigurationValue.Id);
        init();

        modalVm.cancel = function () {
            $uibModalInstance.close('ok');
        };

        modalVm.formSelected = function (index) {
            modalVm.ModalHeading = modalVm.ComplexConfigurationValue.Name;
            modalVm.IsAddNew = false;
            modalVm.MultiFormSettings.selectedFormIndex = index;
        };

        function init() {
            modalVm.ActiveTab = 0;
            modalVm.SortedSelectedList = {};
            modalVm.ComplexConfigurationValue = angular.copy(ComplexConfigurationValue);
            modalVm.ResetComplexConfigurationValue = angular.copy(ComplexConfigurationValue);
            modalVm.ModalHeading = modalVm.ComplexConfigurationValue.Name;
            modalVm.IsSingle = modalVm.ComplexConfigurationValue.XmlSchema.isSingle;
            if (!modalVm.IsSingle) { // multi form settings
                modalVm.MultiFormSettings = {
                    newForm: angular.copy(modalVm.ComplexConfigurationValue.XmlSchema.fieldSequence.splice(modalVm.ComplexConfigurationValue.XmlSchema.fieldSequence.length - 1, 1)),
                    stagingComplexConfig: angular.copy(modalVm.ComplexConfigurationValue.XmlSchema.fieldSequence),
                    selectedFormIndex: 0
                };
            }
        };
    }]);

app.controller('DeleteComplexConfigurationModalController', ['$scope', '$uibModalInstance', 'DeleteModalValues', '$uibModal',
    function ($scope, $uibModalInstance, DeleteModalValues, $uibModal) {
        var modalVm = this;

        init();

        modalVm.cancel = function () {
            $uibModalInstance.close('ok');
        };

        modalVm.deleteEntity = function (value) {
            if (value == 1) {                                
                $uibModalInstance.close(1);
            }
            else {
                $uibModalInstance.dismiss('cancel');
            }
        };

        function init() {
            modalVm.ConfigValue = DeleteModalValues.configValue;
            modalVm.Index = DeleteModalValues.index;
        };
    }]);
